export const ERROR_404_TITLE = '404';
export const ERROR_404_SUBTITLE = "Oops! You're lost.";
export const ERROR_404_DESCRIPTION = 'The page you are looking for was not found.';
